/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { memo } from "react";
import {
  editResponse,
  deleteResponse,
  setResponseId,
} from "../redux/actions/responseAction";
import { useDispatch } from "react-redux";
import { ToastContainer } from "./toast";
import { handleModal } from "../redux/actions/corfirmationModalAction";

const Responses = ({ item, setModalShow }) => {
  const dispatch = useDispatch();

  const handleStatus = async (responseId, status) => {
    let res = await dispatch(editResponse(responseId, status));
    ToastContainer(res);
  };
  const handleDelete = async (responseId) => {
    let res = await dispatch(deleteResponse(responseId));
    ToastContainer(res);
  };
  const setResponse = (responseId, purpose) => {
    dispatch(setResponseId(responseId, purpose));
    setModalShow(true);
  };
  const confirmationModal = (responseId) => {
    dispatch(
      handleModal({
        is_show: true,
        function: handleDelete,
        param: responseId,
      })
    );
  };
  return (
    <div className="card border-0">
      <div className="card-body">
        <div className="row align-items-center gx-5">
          <div className="col-auto">
            <a href="#" className="avatar @@active">
              <span className="avatar-text">
                {item?.title?.charAt(0).toUpperCase()}
              </span>
            </a>
          </div>
          <div className="col">
            <h5
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "200px",
              }}
            >
              <a
                href="#"
                data-bs-toggle="modal"
                data-bs-target="#modal-response"
                onClick={() => setResponse(item?._id, "edit")}
              >
                {item?.title}{" "}
              </a>
            </h5>
            <p
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "200px",
              }}
            >
              Short Code: {item?.short_code}
            </p>
          </div>
          <div className="col-auto">
            <div className="dropdown">
              {!item?.is_response_active && (
                <small style={{ color: "red", marginRight: "10px" }}>
                  <i className="fal fa-ban" />
                </small>
              )}
              <a
                className="icon text-muted"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="fal fa-ellipsis-v"></i>
              </a>
              <ul className="dropdown-menu">
                <li>
                  <a
                    className="dropdown-item"
                    style={{ cursor: "pointer" }}
                    onClick={() => setResponse(item?._id, "edit")}
                    data-bs-toggle="modal"
                    data-bs-target="#modal-response"
                  >
                    Edit Response
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item"
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      handleStatus(item?._id, {
                        is_response_active: !item?.is_response_active,
                      })
                    }
                  >
                    {item?.is_response_active ? "Pause" : "Active"}
                  </a>
                </li>
                <li>
                  <hr className="dropdown-divider" />
                </li>
                <li>
                  <a
                    className="dropdown-item text-danger"
                    style={{ cursor: "pointer" }}
                    onClick={() => confirmationModal(item?._id)}
                  >
                    Delete Response
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default memo(Responses);
